import { ProgressSchema } from '../../models/progress';
import { API_PREFIX, defineEndpoint } from '../endpoint';

/** The character's sheet: level, experience and attributes (CHAR-LEVEL, UX-CHAR). */
export const getProgress = defineEndpoint({
  method: 'GET',
  path: `${API_PREFIX}/character`,
  access: 'session',
  response: ProgressSchema,
});
